module.exports = __webpack_public_path__ + "img/icom4.23eaed7e.png";